/// FOURJS_START_COPYRIGHT(D,2021)
/// Property of Four Js*
/// (c) Copyright Four Js 2021, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("NavigationArrows4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * @class NavigationArrows4STBehavior
   * @memberOf classes
   * @extends classes.StyleBehaviorBase
   */
  cls.NavigationArrows4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.NavigationArrows4STBehavior.prototype */ {
      __name: "NavigationArrows4STBehavior",

      usedStyleAttributes: ["navigationArrows"],
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();
        if (widget?.setNavigationArrows) {
          const navigationArrows = controller.getAnchorNode().getStyleAttribute("navigationArrows");
          if (navigationArrows) {
            widget.setNavigationArrows(this.isSAYesLike(navigationArrows));
          }
        }
      }
    };
  });
});
